import { differenceInCalendarDays } from 'date-fns';
import { UTCDate } from '@date-fns/utc';

// For a campaign, when calculating a time period, it is from the
// start of the first day to the end of the second day
export function diffInDays(startDate: UTCDate, endDate: UTCDate) {
  return differenceInCalendarDays(endDate, startDate) + 1;
}
